const SvgIconHouse = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M15 7.134v6.741a1.166 1.166 0 0 1-1.167 1.167h-2.916a1.167 1.167 0 0 1-1.167-1.167v-2.917a.583.583 0 0 0-.583-.583H6.833a.583.583 0 0 0-.583.583v2.917a1.166 1.166 0 0 1-1.167 1.167H2.167A1.167 1.167 0 0 1 1 13.875V7.134a1.167 1.167 0 0 1 .377-.86L7.21.772l.008-.008a1.167 1.167 0 0 1 1.578.008l5.834 5.504a1.167 1.167 0 0 1 .37.859Z"
    />
  </svg>
)
export default SvgIconHouse
